import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { baseApiUrl, gatewayBaseUrl } from 'environments/environment';

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [baseApiUrl, gatewayBaseUrl],
    sendAccessToken: false
  }
};
